import type { InitialState } from './types';

export function createDefaultInitialState(): InitialState {
  return {
    meta: {
      access_token: '',
      domain: '',
      streaming_api_base_url: '',
      me: '',
      title: '',
      version: '',
      repository: 'TheEssem/mastodon',
      source_url: 'https://github.com/TheEssem/mastodon',
      locale: 'en',
      activity_api_enabled: false,
      limited_federation_mode: false,
      profile_directory: false,
      registrations_open: false,
      search_enabled: true,
      single_user_mode: false,
      trends_enabled: false,
      terms_of_service_enabled: false,
      local_live_feed_access: 'authenticated',
      bubble_live_feed_access: 'authenticated',
      remote_live_feed_access: 'authenticated',
      local_topic_feed_access: 'authenticated',
      bubble_topic_feed_access: 'authenticated',
      remote_topic_feed_access: 'authenticated',
      admin: '',
      boost_modal: false,
      quick_boosting: false,
      favourite_modal: true,
      crop_images: true,
      delete_modal: true,
      missing_alt_text_modal: true,
      auto_play_gif: true,
      display_media: 'default',
      expand_spoilers: false,
      reduce_motion: false,
      disable_swiping: false,
      disable_hover_cards: false,
      advanced_layout: false,
      use_blurhash: true,
      use_pending_items: false,
      show_trends: true,
      mascot: null,
      sso_redirect: '',
      status_page_url: '',
      landing_page: 'about',
      default_content_type: 'text/plain',
      emoji_style: 'auto',
      max_reactions: 1,
      visible_reactions: 8,
      wrapstodon: null,
    },
    accounts: {},
    languages: [],
    max_feed_hashtags: 4,
    max_reactions: 1,
    poll_limits: {
      max_options: 4,
      max_option_chars: 50,
      min_expiration: 300,
      max_expiration: 2629746,
    },
    features: [],
    local_settings: {
      fullwidth_columns: false,
      stretch: true,
      side_arm: 'none',
      side_arm_reply_mode: 'keep',
      show_reply_count: true,
      always_show_spoilers_field: false,
      confirm_boost_missing_media_description: false,
      confirm_before_clearing_draft: true,
      prepend_cw_re: true,
      preselect_on_reply: true,
      inline_preview_cards: true,
      hicolor_privacy_icons: false,
      show_content_type_choice: false,
      tag_misleading_links: true,
      rewrite_mentions: 'no',
      content_warnings: {
        filter: null,
        shared_state: false,
      },
      media: {
        letterbox: true,
        fullwidth: true,
        reveal_behind_cw: false,
        pop_in_player: true,
        pop_in_position: 'right',
      },
      notifications: {
        favicon_badge: false,
        tab_badge: true,
      },
      status_icons: {
        language: true,
        reply: true,
        local_only: true,
        media: true,
        visibility: true,
      },
      show_published_toast: true,
    },
    critical_updates_pending: false,
    compose: {
      me: '',
      default_privacy: 'public',
      default_sensitive: false,
      default_language: undefined,
      default_quote_policy: 'public',
      text: '',
    },
    media_attachments: {
      accept_content_types: [],
    },
    settings: {},
  };
}
